import Constants from "../constants";
import ObjectAssign from "object-assign";
import ParseValidation from "../../../../../helpers/parse-validation";

const initialState = {
    loading: false,
    error: undefined,
};
const reducer = function (state = initialState, action) {
    if (action.type === Constants.GET_DETAILS_RESPONSE) {
        return ObjectAssign({}, initialState);
    }

    if (action.type === Constants.DELETE) {
        return ObjectAssign({}, state, {
            loading: true,
        });
    }

    if (action.type === Constants.DELETE_RESPONSE) {
        const validation = ParseValidation(action.response);

        return ObjectAssign({}, state, {
            loading: false,
            error: validation.error,
        });
    }

    if (action.type === Constants.CLEAN) {
        return ObjectAssign({}, state, {
            loading: true,
        });
    }

    if (action.type === Constants.CLEAN_RESPONSE) {
        const validation = ParseValidation(action.response);

        return ObjectAssign({}, state, {
            loading: false,
            error: validation.error,
            showSaveSuccess: !action.err,
        });
    }

    return state;
};

export default reducer;
